// src/services/groupEventService.js

// Fetch all group events
export async function fetchGroupEvents(apiKey) {
  try {
    const response = await fetch('https://api.simracing.co.uk/v0.1/group_events', {
      headers: { Authorization: `SRL ${apiKey}` },
    });
    const data = await response.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(data, 'text/xml');

    const eventsArray = Array.from(xmlDoc.getElementsByTagName('group_event'));
    return eventsArray.map((event) => ({
      id: event.getElementsByTagName('id')[0]?.textContent,
      name: event.getElementsByTagName('name')[0]?.textContent,
    })).sort((a, b) => a.name.localeCompare(b.name));
  } catch (error) {
    console.error('Error fetching group events:', error);
    return [];
  }
}

// Fetch group event details
export async function fetchGroupEventDetails(eventId, apiKey) {
  try {
    const response = await fetch(`https://api.simracing.co.uk/v0.1/group_events/${eventId}`, {
      headers: { Authorization: `SRL ${apiKey}` },
    });
    const data = await response.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(data, 'text/xml');

    const eventName = xmlDoc.getElementsByTagName('name')[0]?.textContent || '';
    const results = Array.from(xmlDoc.getElementsByTagName('result'));

    const eventResults = results.map((result) => ({
      position: result.getElementsByTagName('position')[0]?.textContent,
      customer_id: result.getElementsByTagName('customer_id')[0]?.textContent,
      customer_name: result.getElementsByTagName('customer_name')[0]?.textContent,
      qualification_points: result.getElementsByTagName('qualification_points')[0]?.textContent || '0',
      race_points: result.getElementsByTagName('race_points')[0]?.textContent || '0',
      fastest_practice_lap_time_str: result.getElementsByTagName('fastest_practice_lap_time_str')[0]?.textContent || 'None',
      fastest_qualification_lap_time_str: result.getElementsByTagName('fastest_qualification_lap_time_str')[0]?.textContent || 'None',
      fastest_race_lap_time_str: result.getElementsByTagName('fastest_race_lap_time_str')[0]?.textContent || 'None',
      total_points: result.getElementsByTagName('total_points')[0]?.textContent || '0',
      race_wins: result.getElementsByTagName('race_wins')[0]?.textContent || '0',
    }));

    const sessions = Array.from(xmlDoc.getElementsByTagName('session')).map((session) => ({
      sessionName: session.getElementsByTagName('name')[0]?.textContent || 'Unknown Session',
      circuitName: session.getElementsByTagName('circuit_name')[0]?.textContent || 'Unknown Circuit',
      sessionType: session.getElementsByTagName('type')[0]?.textContent || 'Unknown Type',
      results: Array.from(session.getElementsByTagName('result')).map((result) => ({
        position: result.getElementsByTagName('position')[0]?.textContent,
        customer_id: result.getElementsByTagName('customer_id')[0]?.textContent,
        customer_name: result.getElementsByTagName('customer_name')[0]?.textContent,
        vehicle_name: result.getElementsByTagName('vehicle_name')[0]?.textContent,
        best_lap: result.getElementsByTagName('fastest_lap_time_str')[0]?.textContent || 'None',
        difference: result.getElementsByTagName('difference_seconds')[0]?.textContent || 'N/A',
        points: result.getElementsByTagName('points')[0]?.textContent || '0',
        penalty_points: result.getElementsByTagName('penalty_points')[0]?.textContent || '0',
        total_points: result.getElementsByTagName('total_points')[0]?.textContent || '0',
      })),
    }));

    return { eventName, eventResults, sessions };
  } catch (error) {
    console.error(`Error fetching details for event ID ${eventId}:`, error);
    return null;
  }
}
